import React from "react";
export const BadgeContext = /*#__PURE__*/React.createContext({
  inGroup: false,
  badgeBorders: false
});
//# sourceMappingURL=BadgeContext.js.map